import { ActionButton } from '@/common/buttons/ActionButton';
import { TitleButton } from '@/common/buttons/TitleButton';
import { useDialog } from '@/common/dialog/DialogContext';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { GridConstants } from '@/common/grid/GridConstants';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useMemo, useState } from 'react';
import { McdInvLifecycleDialog } from './McdInvLifecycleDialog';

export const McdInvList = () => {
  const [selectedEntities, setSelectedEntities] = useState([]);
  const { openDialog } = useDialog();

  const selectedEntityIds = useMemo(() => {
    return selectedEntities.map((selectedEntity) => selectedEntity.id);
  }, [selectedEntities]);

  const handleSelectionChanged = (event) => {
    const gridApi = event.api;
    const selectedNodeData = gridApi.getSelectedNodes().map((node) => node.data);
    setSelectedEntities(selectedNodeData);
  };

  const resetInvData = {
    title: 'Reset Invoice Data',
    entity: 'MCD_INV',
    ids: selectedEntityIds,
    pluginCode: 'MCD_INV_DELETE_ACTION_PLUGIN',
    addlReqData: { ids: selectedEntityIds },
  };

  const undoInvLoadData = {
    title: 'Undo Invoice Load',
    entity: 'MCD_INV',
    ids: selectedEntityIds,
    pluginCode: 'UNDO_MCD_INV_LOAD_ACTION_PLUGIN',
    addlReqData: { ids: selectedEntityIds },
  };

  const augButtons = (buttons) => {
    buttons.push(
      <TitleButton
        key="lifecycleButton"
        dataTestId="mcd-inv-lifecycle-button"
        icon={fas.faPlay}
        toolTip="Run Lifecycle"
        disabled={selectedEntities.length === 0}
        onClick={() => openDialog(McdInvLifecycleDialog, { data: { selectedEntityIds } })}
      />,
      <ActionButton
        data={resetInvData}
        toolTip="Reset Invoice Data"
        icon={fas.faCircleXmark}
        disabled={selectedEntities.length === 0}
      />,
      <ActionButton
        data={undoInvLoadData}
        toolTip="Undo Invoice Load"
        icon={fas.faRotateLeft}
        disabled={selectedEntities.length === 0}
      />,
    );
  };

  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.checkbox = GridConstants.checkbox;

    // 0. Invoice Number
    fieldToFieldDef.invNum.precedence = -1;

    // 1. Dimensions
    fieldToFieldDef.stateId.precedence = 0;
    fieldToFieldDef.stateId.hasName = false;

    fieldToFieldDef.ctrtId.precedence = 1;
    fieldToFieldDef.ctrtId.hasName = false;

    fieldToFieldDef.labelerId.precedence = 2;
    fieldToFieldDef.labelerId.hasName = false;

    fieldToFieldDef.rbtPeriodId.precedence = 3;
    fieldToFieldDef.rbtPeriodId.hasName = false;

    // 2. Statuses
    fieldToFieldDef.status.precedence = 1000;
    fieldToFieldDef.valStatus.precedence = 1001;
    fieldToFieldDef.sumStatus.precedence = 1002;
    fieldToFieldDef.cldStatus.precedence = 1003;

    // // 3. Units
    // fieldToFieldDef.invUnits.precedence = 2000;
    // fieldToFieldDef.dispUnits.precedence = 2001;
    // fieldToFieldDef.dueUnits.precedence = 2002;
    // fieldToFieldDef.paidUnits.precedence = 2003;

    // // 4. URAs
    // fieldToFieldDef.invUra.precedence = 3000;
    // fieldToFieldDef.calcUra.precedence = 3001;

    // 5. Amounts
    // fieldToFieldDef.extInvAmt.precedence = 4000;
    fieldToFieldDef.incrRbtAmt.precedence = 4001;
    fieldToFieldDef.incrDispAmt.precedence = 4002;
    fieldToFieldDef.incrDueAmt.precedence = 4003;
    fieldToFieldDef.incrPaidAmt.precedence = 4004;
    fieldToFieldDef.incrIntrAmt.precedence = 4005;

    // 6. Other
    fieldToFieldDef.mcdInvOrigin.precedence = 9000;
    fieldToFieldDef.postmarkDate.precedence = 9001;
    fieldToFieldDef.dueDate.precedence = 9002;
    fieldToFieldDef.checkRunDate.precedence = 9003;
    fieldToFieldDef.pymtDate.precedence = 9004;
    fieldToFieldDef.lineCount.precedence = 9005;
    fieldToFieldDef.valLineCount.precedence = 9006;
    fieldToFieldDef.mcdStateId.precedence = 9007;
    fieldToFieldDef.mcdInvDateTrackerId.precedence = 9008;
    fieldToFieldDef.payWithoutCld.precedence = 9009;

    // 7. Hide certain fields
    delete fieldToFieldDef.custId;
    delete fieldToFieldDef.invStatus;
  };

  return (
    <EntityList
      entity="MCD_INV"
      augFieldDefs={augFieldDefs}
      augButtons={augButtons}
      gridOptions={{
        rowSelection: 'multiple',
      }}
      events={{
        onSelectionChanged: handleSelectionChanged,
      }}
    />
  );
};
